import useSwiperRef from "../../hooks/useSwiperRef";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import Video from "../../components/Video";
import "swiper/css/bundle";

import { ReactComponent as LeftArrowIcon } from "../../assets/svg/left-arrow.svg";
import { ReactComponent as RightArrowIcon } from "../../assets/svg/right-arrow.svg";

SwiperCore.use([Navigation, Pagination]);



const VideoWithCarousel = ({ props }) => {
    const [nextEl, nextElRef] = useSwiperRef();
    const [prevEl, prevElRef] = useSwiperRef();
    const [paginationEl, paginationRef] = useSwiperRef();

    return (
      <div className="video-with-carousel">
        <div className="left-col-video">
          <Video embedId={props.videoId} />
        </div>
        <div className="right-col-carousel">
          <h3>{props.carouselContent.title}</h3>
          <p
            dangerouslySetInnerHTML={{ __html: props.carouselContent.content }}
          />
          <div className="carousel-small">
            <Swiper
              pagination={{
                el: paginationEl,
              }}
              navigation={{
                prevEl,
                nextEl,
              }}
            >
              {props.carousel.map((panel, idx) => (
                <SwiperSlide key={idx}>
                  {panel.image && (
                    <img
                      src={`${process.env.PUBLIC_URL}${process.env.NODE_ENV === `production` ? `/build` : ``}/images/${panel.image}`}
                      alt=""
                    />
                  )}

                  <p>{panel.title}</p>
                  <div
                    className="carousel-content"
                    dangerouslySetInnerHTML={{ __html: panel.content }}
                  ></div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="carousel-nav">
              <div className="nav-arrow left" ref={prevElRef}>
                <LeftArrowIcon />
              </div>
              <div className="pagination" ref={paginationRef}></div>
              <div className="nav-arrow right" ref={nextElRef}>
                <RightArrowIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default VideoWithCarousel;
